var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:badge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.375 1.25L15.3706 3.125L17.5 3.38375L15.9375 4.79187L16.25 6.875L14.375 5.70312L12.5 6.875L12.8125 4.79187L11.25 3.38375L13.4375 3.125L14.375 1.25Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1981 8.2808L12.9869 7.96955C12.7698 8.80595 12.3096 9.55923 11.6646 10.1342C11.0195 10.7092 10.2185 11.0802 9.36279 11.2001C8.50704 11.3201 7.63493 11.1838 6.85663 10.8083C6.07834 10.4329 5.42878 9.83518 4.99002 9.09074C4.55126 8.34629 4.34299 7.48851 4.39151 6.62575C4.44004 5.763 4.74318 4.93398 5.26265 4.24343C5.78212 3.55288 6.4946 3.03179 7.31009 2.74599C8.12558 2.46018 9.00748 2.42249 9.84438 2.63767L10.1563 1.42705C8.93624 1.1097 7.64496 1.21185 6.49001 1.71705C5.33507 2.22226 4.38356 3.10118 3.78849 4.21249C3.19341 5.3238 2.98934 6.60295 3.20907 7.84426C3.42881 9.08557 4.05959 10.2169 5.00001 11.0564V18.7502L8.75001 16.2502L12.5 18.7502V11.0677C13.3301 10.3278 13.9212 9.3577 14.1981 8.2808ZM11.25 16.4145L8.75001 14.7477L6.25001 16.4145V11.9064C7.02565 12.2961 7.88154 12.4993 8.74956 12.5C9.61758 12.5006 10.4738 12.2987 11.25 11.9102V16.4145Z",
    fill: "#5B5B5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignation);
export default __webpack_public_path__ + "static/media/designation.4d70efa3ac8f807b472ccb6f0b980de2.svg";
export { ForwardRef as ReactComponent };